import {
  IN_TRANSIT_FIELDS,
  TRANSFER_FIELDS,
  WAREHOUSE_FIELDS,
} from "@/modules/warehouses/fields";
import { InTransit } from "@/modules/warehouses/screens/InTransit";
import { TransfersList } from "@/modules/warehouses/screens/TransfersList";
import { WarehouseList } from "@/modules/warehouses/screens/WarehouseList";
import type { ModuleUi } from "@/modules/types";

/**
 * The Warehouses module.
 *
 * Three sections, three unrelated row shapes: the warehouse master,
 * transfers, and a view over transfers that exists nowhere in Shopify
 * (FR-WHS-12, see `in-transit.ts`). Each declares its own vocabulary, which
 * is why fields belong to the section — a shared list would have opened
 * Transfers with warehouse columns.
 */
export const warehousesModule: ModuleUi = {
  id: "warehouses",
  sections: {
    list: { fields: WAREHOUSE_FIELDS, screen: WarehouseList },
    transfers: { fields: TRANSFER_FIELDS, screen: TransfersList },
    "in-transit": {
      fields: IN_TRANSIT_FIELDS,
      screen: InTransit,
      nothingYet: {
        title: "Nothing in transit",
        description: "A transfer shows here once it is dispatched.",
      },
    },
  },
};
